import Auth from './Auth.vue'
import LoginPage from './login'
import ForgotPage from './forgot'
import NewPasswordPage from './new-password'
import AuthorizeMobilePay from './authorize'
import SetPasswordPage from './set-password'

const authRoutes = [
    LoginPage,
    NewPasswordPage,
    AuthorizeMobilePay,
    SetPasswordPage,
    ForgotPage
]
export default {
    path:'/auth', children: authRoutes, component:Auth
}